<div>
  <ng-template #switchUserPopup1>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" mat-button (click)="cancelSwitchUserPopup()">
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{labelName}} </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label id="user-validation" for="email">{{labelName}}
              <span class="mandatory-symbol">*</span>
            </label>
          </div>
          <!-- <ng-multiselect-dropdown id="module" class="multiselect-container" style="position: absolute; width: 91%;"
            [(ngModel)]="message.switchedUser" [settings]="singleSelectDropdownSetting"
            [data]="message.switchUserdropDownList" (onSelect)="onUserSelect()" (onDeSelect)="onUserDeSelect()">
          </ng-multiselect-dropdown> -->
          <mat-select matInput placeholder="Select" [(ngModel)]="message.switchedUser" (closed)="switchUserTxt=''"
            (click)="focusmethod('switchedUserSearch')">
            <input type="search" id="switchedUserSearch" class="dropdownsearchstyle" [(ngModel)]="switchUserTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of message.switchUserdropDownList| assessmentSearch :switchUserTxt"
              (onSelectionChange)="onUserSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-12" *ngIf="switchPageName !== 'FORMS'">
          <div>
            <label id="switch-reason-validation" for="email">Reason
              <span class="mandatory-symbol">*</span>
            </label>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="reasonForSwitch"
            (ngModelChange)="mandatoryValidation($event,'switch-reason-validation')"></textarea>
        </div>
      </div>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
      <button mat-stroked-button class="addButton" (click)="switchUserFunction()">
        <i class="fas fa-user-edit"></i> Switch
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSwitchUserPopup()">
        <i class="fas fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

  <ng-template #confirmationPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeConfirmationPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Confirmation </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="center">
      <label for="email" style="font-size: medium; font-weight: bold;">
        Do you want to Switch {{labelName}}?</label>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
      <button mat-stroked-button class="addButton" (click)="executeUserSwitch()">
        <i class="fa fa-check"></i> Yes
      </button>
      <button mat-stroked-button class="cancelButton" (click)="closeConfirmationPopup()">
        <i class="fas fa-close"></i> No
      </button>
    </div>
  </ng-template>
</div>